<zimmerer-route-ion-wrapper class="ion-page">

  <div class="threecol"
    fxLayout="column"
    fxLayoutAlign.gt-md="center center">
    <div class="main-col noSlider"
      fxLayout="column"
      fxLayoutGap="20px">

      <div style="text-align: center;">
        Zimmerer-Treffpunkt GmbH<br>
        Ziegelweg 5, 94405 Landau<br><br>
        Kontaktiere uns über Email oder Telefon:<br>
        Email: <a href="mailto:info@zimmerer-treff.com">info@zimmerer-treff.com</a><br>
        Telefon: <a href="tel:+49 9951 9574700">+49 (0) 9951 9574700</a><br>
      </div>

    </div>
  </div>

  <app-footer></app-footer>

</zimmerer-route-ion-wrapper>
